import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MainLayout } from './components/layout/MainLayout';
import { Dashboard } from './components/dashboard/Dashboard';
import { ProductCatalog } from './components/products/ProductCatalog';
import { ProductDetails } from './components/products/ProductDetails';
import { EnquiriesModule } from './components/enquiries/EnquiriesModule';
import { BookingsModule } from './components/bookings/BookingsModule';
import { WaitingListModule } from './components/waitingList/WaitingListModule';
import { CustomersModule } from './components/customers/CustomersModule';
import { ReportsModule } from './components/reports/ReportsModule';
import { DocumentsModule } from './components/documents/DocumentsModule';
import { ComparisonTool } from './components/comparison/ComparisonTool';
import { EnquiryDetails } from './components/enquiries/EnquiryDetails';
import { BookingDetails } from './components/bookings/BookingDetails';
import { PresentationModeProvider } from './contexts/PresentationModeContext';
import { ChatProvider } from './contexts/ChatContext';
import { RecordingProvider } from './contexts/RecordingContext';
import { ClosingAssistantProvider } from './contexts/ClosingAssistantContext';
import { AISalesAssistantProvider } from './contexts/AISalesAssistantContext';
import { RecordingsList } from './components/conversation/RecordingsList';
import { RecordingDetails } from './components/conversation/RecordingDetails';
import { AISalesAssistant } from './components/ai-assistant/AISalesAssistant';
export function App() {
  const [isOffline, setIsOffline] = useState(false);
  // Simulate occasional network status changes
  useEffect(() => {
    const checkNetworkStatus = () => {
      setIsOffline(Math.random() > 0.8); // 20% chance of being offline for demo purposes
    };
    checkNetworkStatus();
    const interval = setInterval(checkNetworkStatus, 30000);
    return () => clearInterval(interval);
  }, []);
  return <PresentationModeProvider data-id="element-0">
      <ChatProvider data-id="element-1">
        <RecordingProvider data-id="element-2">
          <ClosingAssistantProvider data-id="element-3">
            <AISalesAssistantProvider data-id="element-4">
              <Router data-id="element-5">
                <MainLayout isOffline={isOffline} data-id="element-6">
                  <Routes data-id="element-7">
                    <Route path="/dashboard" element={<Dashboard data-id="element-9" />} data-id="element-8" />
                    <Route path="/products" element={<ProductCatalog data-id="element-11" />} data-id="element-10" />
                    <Route path="/products/:id" element={<ProductDetails data-id="element-13" />} data-id="element-12" />
                    <Route path="/compare" element={<ComparisonTool data-id="element-15" />} data-id="element-14" />
                    <Route path="/enquiries" element={<EnquiriesModule data-id="element-17" />} data-id="element-16" />
                    <Route path="/enquiries/:id" element={<EnquiryDetails data-id="element-19" />} data-id="element-18" />
                    <Route path="/bookings" element={<BookingsModule data-id="element-21" />} data-id="element-20" />
                    <Route path="/bookings/:id" element={<BookingDetails data-id="element-23" />} data-id="element-22" />
                    <Route path="/waitinglist" element={<WaitingListModule data-id="element-25" />} data-id="element-24" />
                    <Route path="/customers" element={<CustomersModule data-id="element-27" />} data-id="element-26" />
                    <Route path="/reports" element={<ReportsModule data-id="element-29" />} data-id="element-28" />
                    <Route path="/documents" element={<DocumentsModule data-id="element-31" />} data-id="element-30" />
                    <Route path="/recordings" element={<RecordingsList data-id="element-33" />} data-id="element-32" />
                    <Route path="/recordings/:id" element={<RecordingDetails data-id="element-35" />} data-id="element-34" />
                    <Route path="*" element={<Navigate to="/dashboard" replace data-id="element-37" />} data-id="element-36" />
                  </Routes>
                  <AISalesAssistant data-id="element-38" />
                </MainLayout>
              </Router>
            </AISalesAssistantProvider>
          </ClosingAssistantProvider>
        </RecordingProvider>
      </ChatProvider>
    </PresentationModeProvider>;
}